import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

export default function (props) {
    const [ visible, setVisible ] = useState(false);
    // console.log(props)
    useEffect(() => {
        // console.log(`Tab :` + props.statusTab)
        // console.log(`Total data :` + props.data[props.statusTab])
        // console.log(`Current page: ` + props.page)
        const totalPage = Math.ceil(props.data[props.statusTab]/props.limit);
        // console.log(`Total Page: ` + totalPage)
        if (totalPage > props.page) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    },[props.totalOrders])

    if (!visible) {
        return null
    };

    if (props.loadingView) {
        return null
    }
    
    return (
        <div className="m-4 text-center">
            <div className="load-more-orders">
                <text onClick={props.onClick} className="text-info bold py-2 px-4 shadow btn bg-white">
                    <b>{props.loading ? "loading... " : "Load More Order"}</b>
                </text>
            </div>
        </div>
    )
}